import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { ClockIcon } from 'images'
import PlayHistoryActions from 'reducers/PlayHistory'
import { thunks as PlayQueueThunks } from 'reducers/PlayQueue'
import { CollectionContent, DialogModal, ReleasesTable } from 'components'
import { PLAY_SOURCES, PLAY_TRIGGERS } from 'constants/tracking'

const mapStateToProps = ({ playHistory }) => ({
  songs: playHistory.songs
})

export class RecentlyPlayedContent extends React.PureComponent {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    songs: PropTypes.arrayOf(PropTypes.object).isRequired,
    t: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)

    this.state = {
      showClearListModal: false
    }
  }

  handleClearConfirmClick = () => {
    const { dispatch } = this.props
    dispatch(PlayHistoryActions.clearList())
    this.setState({ showClearListModal: false })
  }

  handleClearCancelClick = () => {
    this.setState({ showClearListModal: false })
  }

  // History rows are songs, so play the clicked track instead of its release
  handlePlaySong = (song) => {
    const { dispatch } = this.props
    dispatch(
      PlayQueueThunks.playSong(song, {
        source: PLAY_SOURCES.HISTORY,
        trigger: PLAY_TRIGGERS.ROW
      })
    )
  }

  showClearListModal = () => {
    this.setState({ showClearListModal: true })
  }

  renderClearListModal = () => {
    const { t } = this.props

    return (
      <DialogModal
        title={t('collections.clear-recent')}
        onClickYes={this.handleClearConfirmClick}
        onClickCancel={this.handleClearCancelClick}>
        <div className="w-full flex flex-col items-center my-10 text-sm font-header">
          {t('collections.recent-dialog-body')}
        </div>
      </DialogModal>
    )
  }

  renderTable = () => {
    const { songs } = this.props

    return (
      <div className="overflow-auto scrollbar flex-1">
        <ReleasesTable
          downloadSource="recently_played_releases_table"
          items={songs}
          onPlay={this.handlePlaySong} />
      </div>
    )
  }

  render() {
    const { t } = this.props
    const { showClearListModal } = this.state

    return (
      <>
        <CollectionContent
          actionCallback={this.showClearListModal}
          actionTitle={t('collections.clear-list')}
          icon={<ClockIcon />}
          table={this.renderTable()}
          title={t('collections.recently-played')} />
        {showClearListModal && this.renderClearListModal()}
      </>
    )
  }
}

const ConnectedRecentlyPlayedContent = connect(mapStateToProps)(
  RecentlyPlayedContent
)

export default withTranslation()(ConnectedRecentlyPlayedContent)
